import axios from 'axios';

// Dedicated axios instance for the Major Milestones module (/api/milestones).
const milestonesApi = axios.create({ baseURL: '/api/milestones', withCredentials: true });

milestonesApi.interceptors.request.use(cfg => {
  const token = localStorage.getItem('flowup_token');
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});
milestonesApi.interceptors.response.use(res => res.data, err => Promise.reject(err.response?.data || { error: 'Request failed' }));

export default milestonesApi;
